import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '',
    templateUrl: './gray-user.component.svg',
    styleUrls: ['./gray-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GrayUserComponent {}
